import React from "react";
import SeoHead from "../../../../components/SeoHead";
import EventOrganizersHero from "./EventOrganizersHero";
import SmartPlatform from "./SmartPlatform";
import PaymentStruggles from "./PaymentStruggles";
import WhyOrganizersLove from "./WhyOrganizersLove";
import HowNdovuWorks from "./HowNdovuWorks";
import { eventOrganizersConfig as config } from "../serviceConfig";

function EventOrganizers() {
  return (
    <div id="event-organizers">
      <SeoHead title="Event Organizers" description="Pay staff and vendors without chaos. Disburse payments instantly before, during or after events with Impala Digital Payments." path="/services/event-organizers" />
      <EventOrganizersHero hero={config.hero} />
      <SmartPlatform platform={config.platform} />
      <PaymentStruggles struggles={config.struggles} />
      <HowNdovuWorks how={config.how} />
      <WhyOrganizersLove why={config.why} />
    </div>
  );
}

export default EventOrganizers;
